<template>
    <section>
        <div class="main_section1" style="display: flex; flex-direction: column; justify-content: flex-end; position: relative; ">
            <div class="mobile_con_wrap" style="height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 30px; font-weight: 500; color: white; text-align: center; color: #E4E4E4">
                    교육 시장의<br>
                    불평등을 해소하는<br>
                    사회적 가치를<br>
                    추구합니다
                </p>
                <chevron-down-icon size="1.7x" class="arrow_bottom"></chevron-down-icon>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon
    }

}
</script>
<style>
    .main_section1 {
        width: 100vw;
        height:calc(var(--vh, 1vh) * 100);
        background: url('../../../../../../assets/images/main_v2/background_section1.svg') no-repeat;
        object-fit: inherit;
    }
</style>
